/**
 * 月报信息汇总处理
 * chenxiaojian 2020-02-14
 */
import React from 'react';

import { Row, Col, Select, Empty, Card, Table, Statistic, Progress, Button } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';

import { fixedNumber } from '../../../util/util';

import Loading from '../../ui/Loading';

class MonthWriteIndex extends React.Component {

    //统计信息的数据
    statisticFields = [{
        "field": "hasStaff",
        "text": "在职编制人数",
    }, {
        "field": "hasEpiboly",
        "text": "在职外包人数",
    }, {
        "field": "budgetStaff",
        "text": "预算编制人数",
    }, {
        "field": "budgetEpiboly",
        "text": "预算外包人数",
    }, {
        "field": "addStaff",
        "text": "入职编制人数",
    }, {
        "field": "minusStaff",
        "text": "离职编制人数",
    }, {
        "field": "addEpiboly",
        "text": "入职外包人数",
    }, {
        "field": "minusEpiboly",
        "text": "离职外包人数",
    }];

    //项目纬度字段
    budgetColumns = [{
        title: '项目',
        dataIndex: 'itemName',
        width: '15%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"],
                    colSpan: row["colSpan"] != null ? row["colSpan"] : 1
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'subName',
        width: '10%',
        colSpan: 0,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    colSpan: row["colSpan"] != null ? 0 : 1
                },
            };
        },
    }, {
        title: '本月累计执行',
        dataIndex: 'month',
        width: '15%',
    }, {
        title: '年度预算目标',
        dataIndex: 'yearBudget',
        width: '15%',
    }, {
        title: '年度累计执行',
        dataIndex: 'year',
        width: '15%',
    }, {
        title: '年度执行进度',
        dataIndex: 'reportId',
        width: '30%',
        render: (text, record, index) => {
            return <Progress percent={fixedNumber((record["year"] / record["yearBudget"] * 100).toFixed(2), 2)} />;
        }
    }];

    //部门纬度字段
    businessColumns = [{
        title: '部门',
        dataIndex: 'orgName',
        width: '10%',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["orgLength"]
                },
            };
        },
    }, {
        title: '项目',
        dataIndex: 'itemName',
        width: '10%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"],
                    colSpan: row["colSpan"] != null ? row["colSpan"] : 1
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'subName',
        width: '10%',
        colSpan: 0,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    colSpan: row["colSpan"] != null ? 0 : 1
                },
            };
        },
    }, {
        title: '本月累计执行',
        dataIndex: 'month',
        width: '15%',
    }, {
        title: '年度预算目标',
        dataIndex: 'yearBudget',
        width: '15%',
    }, {
        title: '年度累计执行',
        dataIndex: 'year',
        width: '15%',
    }, {
        title: '年度执行进度',
        dataIndex: 'reportId',
        width: '25%',
        render: (text, record, index) => {
            return <Progress percent={fixedNumber((record["year"] / record["yearBudget"] * 100).toFixed(2), 2)} />;
        }
    }];

    activityColumns = [{
        title: '活动名称',
        dataIndex: 'name',
        width: '10%'
    }, {
        title: '活动类型',
        dataIndex: 'type',
        width: '10%',

    }, {
        title: '活动投放',
        dataIndex: 'launch',
        width: '10%',
    }, {
        title: '活动费用',
        dataIndex: 'fees',
        width: '10%',
    }, {
        title: '活动概述',
        dataIndex: 'summary',
        width: '60%',
    }];

    workColumns = [{
        title: '部门',
        dataIndex: 'orgName',
        width: '10%',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["orgLength"]
                },
            };
        },
    }, {
        title: '项目',
        dataIndex: 'mainName',
        width: '10%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"] != null ? row["rowSpan"] : 0
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'itemName',
        width: '10%',
        colSpan: 0
    }, {
        title: '本月工作计划',
        dataIndex: 'thisPlan',
        width: '20%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            return this.string2Html(value);
        }
    }, {
        title: '本月主要工作内容',
        dataIndex: 'thisWork',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            return this.string2Html(value);
        }
    }, {
        title: '下月工作计划',
        dataIndex: 'nextPlan',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            return this.string2Html(value);
        }
    }];

    string2Html = (value) => {
        value = value == null ? value : value.replace(/\n/g, '<br/>');
        return <div dangerouslySetInnerHTML={{ __html: value }} />
    }

    state = {
        //查询数据
        queryData: {
            year: moment().year(),
        },
        yearList: [],
        orgList: [],    //有编制预算的部门信息
        data: [],   //用于页面展示渲染的数据
        activity: {},   //市场活动
        loadingVisible: false
    };

    componentDidMount() {
        let year = moment().year();
        //开始年份从2019开始，然后累加到当前年份的下一年
        let yearList = [];
        for (let i = 2019; i <= year + 1; i++) {
            yearList.push(i);
        }
        this.setState({ yearList: yearList });
        this.loadData(this.state.queryData);
    }

    //加载数据，用于页面渲染
    loadData = (queryData) => {
        http.get({
            url: "/reportMonth/sum/findMonthReportSum",
            data: queryData,
            success: (map) => {
                let res = map["work"];
                let activity = map["activity"];
                let resultList = [];    //最终返回到页面显示的数据列表
                if (res != null && res.length > 0) {
                    let result = {};    //以month为key,列表的结果为值，用于快速获取要处理的月份数据
                    for (let i = 0; i < res.length; i++) {
                        let r = result[res[i]["month"]];
                        if (r == null) {
                            r = {
                                hasStaff: 0,
                                budgetStaff: 0,
                                addStaff: 0,
                                minusStaff: 0,
                                hasEpiboly: 0,
                                budgetEpiboly: 0,
                                addEpiboly: 0,
                                minusEpiboly: 0,
                                month: res[i]["month"],
                                business: [],
                                work: [],
                                budget: [],
                            };
                            resultList.push(r);
                        }
                        r.hasStaff += res[i]["hasStaff"];
                        r.budgetStaff += res[i]["budgetStaff"];
                        r.addStaff += res[i]["addStaff"];
                        r.minusStaff += res[i]["minusStaff"];
                        r.hasEpiboly += res[i]["hasEpiboly"];
                        r.budgetEpiboly += res[i]["budgetEpiboly"];
                        r.addEpiboly += res[i]["addEpiboly"];
                        r.minusEpiboly += res[i]["minusEpiboly"];

                        let subNode = res[i].subNode;
                        let business = [];  //业务项目
                        let work = [];  //工作项目
                        let budget = [];    //财务预算
                        let itemName = "收入合计";
                        if (res[i].orgName != null && res[i].orgName.startsWith("财务")) {
                            itemName = "经营利润";
                        }
                        let businessSum = {
                            "month": 0,
                            "year": 0,
                            "yearBudget": 0,
                            "itemName": res[i].orgName + itemName,
                            "colSpan": 2,
                            "key": "-" + i,
                            "rowSpan": 1,
                        };
                        let budgetNumSum = {
                            "key": "-1",
                            "month": 0,
                            "year": 0,
                            "yearBudget": 0,
                            "itemName": "小计",
                            "subName": "毛利",
                            "rowSpan": 0,
                        };
                        let budgetMoneySum = {
                            "key": "-0",
                            "month": 0,
                            "year": 0,
                            "yearBudget": 0,
                            "itemName": "小计",
                            "subName": "收入",
                            "rowSpan": 2,
                        };
                        let sumFlag = 0;
                        if (subNode != null && subNode.length > 0) {
                            for (let j = 0; j < subNode.length; j++) {
                                if (subNode[j].type === 1) {
                                    let num = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-0",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "数量",
                                        "month": subNode[j]["incomeNum"],
                                        "year": subNode[j]["yearNum"],
                                        "yearBudget": subNode[j]["numBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "orgName": subNode[j]["orgName"],
                                        "rowSpan": 2,
                                    };
                                    let money = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-1",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "金额",
                                        "month": subNode[j]["incomeMoney"],
                                        "year": subNode[j]["yearMoney"],
                                        "yearBudget": subNode[j]["moneyBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "orgName": subNode[j]["orgName"],
                                        "rowSpan": 0,
                                    };

                                    if (itemName === "经营利润") {
                                        //针对财务部的信息做特殊处理
                                        let factor = 1;
                                        if (subNode[j]["itemName"] === "收入") {
                                            factor = 0;
                                        } else if (subNode[j]["itemName"] === "毛利") {
                                            factor = 1;
                                        } else if (subNode[j]["itemName"] === "税金及费用") {
                                            factor = -1;
                                        }
                                        businessSum["month"] += money["month"] * factor;
                                        businessSum["year"] += money["year"] * factor;
                                        businessSum["yearBudget"] += money["yearBudget"] * factor;
                                    } else {
                                        businessSum["month"] += money["month"];
                                        businessSum["year"] += money["year"];
                                        businessSum["yearBudget"] += money["yearBudget"];
                                    }
                                    if (subNode[j]["onlyMoney"] === 1) {
                                        // money["colSpan"] = 2;
                                        money["rowSpan"] = 1;
                                    } else {
                                        business.push(num);
                                    }
                                    business.push(money);
                                    sumFlag++;
                                } else if (subNode[j].type === 2) {
                                    let s = subNode[j]["subNode"];
                                    if (s == null || s.length === 0) {
                                        subNode[j]["rowSpan"] = 1;
                                        subNode[j]["tableIndex"] = i;
                                        work.push(subNode[j]);
                                    } else {
                                        s[0]["mainName"] = subNode[j]["itemName"];
                                        s[0]["rowSpan"] = s.length;
                                        s.forEach(item => {
                                            item["tableIndex"] = i;
                                            work.push(item)
                                        });
                                    }
                                } else if (subNode[j].type === 3) {
                                    let num = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-0",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "毛利",
                                        "month": subNode[j]["incomeNum"],
                                        "year": subNode[j]["yearNum"],
                                        "yearBudget": subNode[j]["numBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "rowSpan": 0,
                                    };
                                    let money = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-1",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "收入",
                                        "month": subNode[j]["incomeMoney"],
                                        "year": subNode[j]["yearMoney"],
                                        "yearBudget": subNode[j]["moneyBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "rowSpan": 2,
                                    };

                                    budgetNumSum["month"] += num["month"];
                                    budgetNumSum["year"] += num["year"];
                                    budgetNumSum["yearBudget"] += num["yearBudget"];

                                    budgetMoneySum["month"] += money["month"];
                                    budgetMoneySum["year"] += money["year"];
                                    budgetMoneySum["yearBudget"] += money["yearBudget"];
                                    budget.push(money);
                                    budget.push(num);
                                }
                            }
                        }
                        if (sumFlag > 1) {
                            business.push(businessSum);
                        }

                        if (business != null && business.length > 0) {
                            for (let t in business) {
                                business[t]["orgLength"] = 0;
                                r["business"].push(business[t]);
                            }
                            business[0]["orgLength"] = business.length;
                        }
                        if (work != null && work.length > 0) {
                            for (let t in work) {
                                work[t]["orgLength"] = 0;
                                r["work"].push(work[t]);
                            }
                            work[0]["orgLength"] = work.length;
                        }
                        if (budget != null && budget.length > 0) {
                            budget.push(budgetMoneySum);
                            budget.push(budgetNumSum);
                            for (let t in budget) {
                                r["budget"].push(budget[t]);
                            }
                        }
                        // r["budget"] = budget;
                        //以month为key，每个月的汇总为结果的显示
                        result[res[i]["month"]] = r;
                    }
                }
                this.setState({ data: resultList, activity: activity });
            }
        });
    }



    selectChange = (newYear) => {
        let { queryData } = this.state;
        let oldYear = queryData.year;
        queryData.year = newYear;
        this.setState({ queryData: queryData });
        //如果没有改变年份，则不用再加载部门数据，直接加载查询数据，否则需先加载部门数据
        if (oldYear === newYear) {
        } else {
            this.loadData(queryData);
        }
    }

    extra = (index) => {
        let dom = [];
        dom.push(<Button key="download" type="primary" onClick={this.download.bind(this, index)}>导出</Button>);
        return dom;
    }

    /**
     * 导出数据
     */
    download = (index) => {
        this.setState({ loadingVisible: true });
        let value = this.state.data[index];
        let activity = this.state.activity[value["month"]];
        value.activity = activity;
        http.download({
            url: '/reportMonth/sum/downloadMonthReportSum',
            data: { downloadJson: JSON.stringify(value) },
            fileName: value["month"] + "月报信息.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <Row>
                    <Col span={24}>
                        <Select onChange={this.selectChange} defaultValue={moment().year()} allowClear={false} style={{ width: "100px", margin: '0 10px' }}>
                            {this.state.yearList.map(item => (
                                <Select.Option key={item}>{item}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
                <Row>
                    {this.state.data == null || this.state.data.length === 0 ?
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        :
                        this.state.data.map((value, index) => {
                            return <Col span={24} style={{ margin: "10px 0" }} key={index}>
                                <Card title={value['month'] + " 月报"} bordered={true} extra={this.extra(index)}>
                                    <Card.Grid style={gridStyle} kye="基本信息">
                                        <Row>
                                            {this.statisticFields.map((item, subIndex) => {
                                                return <Col span={3} key={subIndex}>
                                                    <Statistic title={item.text} value={value[item.field]} />
                                                </Col>;
                                            })}
                                        </Row>
                                    </Card.Grid>
                                    {value["budget"] != null && value["budget"].length > 0 ?
                                        <Card.Grid style={gridStyle} kye="预算指标">
                                            <Table rowKey="key" columns={this.budgetColumns} dataSource={value["budget"]} tableLayout="fixed" pagination={false} bordered={true} />
                                        </Card.Grid>
                                        : ''
                                    }
                                    <Card.Grid style={gridStyle} kye="执行计划">
                                        <Table rowKey="key" columns={this.businessColumns} dataSource={value["business"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="市场活动">
                                        <Table rowKey="id" columns={this.activityColumns} dataSource={this.state.activity[value["month"]]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="工作任务">
                                        <Table rowKey="code" columns={this.workColumns} dataSource={value["work"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                </Card>
                            </Col>
                        })
                    }
                </Row>

                <Loading visible={this.state.loadingVisible} message="正在处理中，请稍候..." />
            </div>
        )
    }
}

const gridStyle = {
    width: '100%',
    textAlign: 'center',
};

const tableTextStyle = {
    style: {
        overflow: 'visible',
        whiteSpace: 'normal',
    }
}

export default MonthWriteIndex;